import React from "react";
import { Table, TableBody, TableContainer, TableHead, TableRow, Paper, Typography } from "@material-ui/core";
import {AiFillFilePdf} from 'react-icons/ai'
import TableCell, { tableCellClasses } from "@mui/material/TableCell";
import { styled } from '@mui/material/styles';

const rows = [
  { slNo: 1, description: "LIST OF REGISTERED COLONIES APPROVED UNDER H.P. APARTMENT AND PROPERTY REGULATION ACT, 2005", pdfUrl: "https://www.tcp.hp.gov.in/Application/uploadDocuments/content/Licence_Cases_1_1.pdf" },
]
const rows2 = [
    { slNo: 1, description: "LIST OF ESSENTIALITY CERTIFICATE", pdfUrl: "https://www.tcp.hp.gov.in/Application/uploadDocuments/content/EC_list.pdf" },
  ]
const StyledTableCell = styled(TableCell)(({ theme }) => ({
  [`&.${tableCellClasses.head}`]: {
    backgroundColor: "#1f4a7c",
    color: theme.palette.common.white,
    fontSize: 16
  },
  [`&.${tableCellClasses.body}`]: {
    fontSize: 14,
  },
}));

const StyledTableRow = styled(TableRow)(({ theme }) => ({
  "&:nth-of-type(odd)": {
    backgroundColor: theme.palette.action.hover,
  },
  "&:last-child td, &:last-child th": {
    border: 0,
  },
}));
const handlePdfDownload = (pdfUrl) => {
  window.open(pdfUrl);
};

const LicenseCertificate = () => {
  return (
    <React.Fragment>
    <TableContainer component={Paper}>
    <Typography variant='h6' style={{margin: '20px'}}>
    License and Essentiality Certifiate
    </Typography>
      <Table aria-label="Sample Table" style={{width: '90%', margin: '30px'}}>
        <TableHead>
          <StyledTableRow style={{background: '#1F4A7C', height: '20px', color: 'white'}}>
            <StyledTableCell style={{color: 'white', border: '1px solid #ffff'}}>SL. No</StyledTableCell>
            <StyledTableCell style={{color: 'white', border: '1px solid #ffff'}}>Subject</StyledTableCell>
            <StyledTableCell style={{color: 'white', border: '1px solid #ffff'}}>Download</StyledTableCell>
          </StyledTableRow>
        </TableHead>
        <TableBody>
          {rows.map((row) => (
            <StyledTableRow key={row.slNo}>
              <StyledTableCell component="th" scope="row">
                {row.slNo}
              </StyledTableCell>
              <StyledTableCell>{row.description}</StyledTableCell>
              <StyledTableCell onClick={() => handlePdfDownload(row.pdfUrl)}><AiFillFilePdf style={{width: '30px', height: '30px', color:'#f44b55', cursor: 'pointer' }}/></StyledTableCell>
            </StyledTableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>

    <TableContainer component={Paper}>
    <Typography variant='h6' style={{margin: '20px'}}>
    Essentiality Certifiate
    </Typography>
      <Table aria-label="Sample Table" style={{width: '90%', margin: '30px'}}>
        <TableHead>
          <StyledTableRow style={{background: '#1F4A7C', height: '20px', color: 'white'}}>
            <StyledTableCell style={{color: 'white', border: '1px solid #ffff'}}>SL. No</StyledTableCell>
            <StyledTableCell style={{color: 'white', border: '1px solid #ffff'}}>Subject</StyledTableCell>
            <StyledTableCell style={{color: 'white', border: '1px solid #ffff'}}>Download</StyledTableCell>
          </StyledTableRow>
        </TableHead>
        <TableBody>
          {rows2.map((row) => (
            <StyledTableRow key={row.slNo}>
              <StyledTableCell component="th" scope="row">
                {row.slNo}
              </StyledTableCell>
              <StyledTableCell>{row.description}</StyledTableCell>
              <StyledTableCell onClick={() => handlePdfDownload(row.pdfUrl)}><AiFillFilePdf style={{width: '30px', height: '30px', color:'#f44b55', cursor: 'pointer' }}/></StyledTableCell>
            </StyledTableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
    </React.Fragment>
  );
};

export default LicenseCertificate;
